const APP = {
    DOMAIN: process.env.VUE_APP_BACKEND_PATH
};
export default APP;